import React from "react";
import { Card, PageHeader } from "../../../components/common";

const StudentDashboard: React.FC = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <Card style={{ padding: "24px" }}>
        <PageHeader
          title="Student Dashboard"
          subtitle="Welcome to your Akshar Art Student Portal."
        />
      </Card>
    </div>
  );
};

export default StudentDashboard;
